import axiosInstance from "./api_helper";

const transporteurService = {
    list: async () => {
        return axiosInstance.get('/api/transporteurs');
    },
    addTransporteur: async (payload) => {
        return await axiosInstance.post('/api/transporteurs', payload); 
    },
    update: async (id, data) => {
        return axiosInstance.put(`/api/transporteurs/${id}`, JSON.stringify(data));
    }
};

export default transporteurService;